import React from "react";
import { Box, SxProps, Typography } from "@mui/material";
import theme from "Theme/AppTheme";

const InputContainer = ({
    children,
    label,
    sx,
}: {
    children: React.ReactNode;
    label: string;
    sx?: SxProps;
}) => (
    <Box sx={{ display: "flex", alignItems: "center", ...sx }}>
        <Typography
            sx={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "24px",
                color: theme.palette.gray.main,
                flex: 3,
            }}
        >
            {label}
        </Typography>
        <Box sx={{ flex: 9 }}>{children}</Box>
    </Box>
);

export default InputContainer;
